module.exports = __webpack_public_path__ + "static/media/logo_blue.0f528d30.png";